import { Model } from "__graphql__/types";

import { useGetModelsQuery } from "../queries/assets.generated";

interface Supplier {
  id: string;
  name: string;
  models: Pick<Model, "modelId" | "name">[];
}

interface ModelsBySupplier {
  [supplierId: string]: Supplier;
}

export function useSuppliersAndModels(): {
  suppliers: Pick<Supplier, "id" | "name">[];
  modelsBySupplier: ModelsBySupplier;
} {
  const { data: modelsData } = useGetModelsQuery();

  const modelsBySupplier = new Map<string, Supplier>();

  modelsData?.getModels.models.forEach((model: Model) => {
    if (!model?.supplier?.id) return;

    const hasSupplier = modelsBySupplier.has(model.supplier.id);
    const newModel = { modelId: model.modelId, name: model.name };

    if (hasSupplier) {
      const existingSupplier = modelsBySupplier.get(model.supplier.id);
      existingSupplier?.models.push(newModel);
    } else {
      const newSupplier = {
        id: model.supplier.id,
        name: model.supplier.name,
        models: [newModel],
      };
      modelsBySupplier.set(model.supplier.id, newSupplier);
    }
  });

  return {
    suppliers: Array.from(modelsBySupplier.values()).map(({ id, name }) => ({ id, name })),
    modelsBySupplier: Object.fromEntries(modelsBySupplier),
  };
}
